var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "appointment-soon-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M14.625,0a14.625,14.625,0,0,0,0,29.25c.387,0,.747-.044,1.125-.07v-4.57a9.6,9.6,0,0,1-1.125.141A10.125,10.125,0,1,1,24.75,14.625a9.6,9.6,0,0,1-.141,1.125h4.57c.026-.378.07-.738.07-1.125A14.659,14.659,0,0,0,14.625,0Zm0,6.75A1.122,1.122,0,0,0,13.5,7.875V13.5H10.125a1.125,1.125,0,0,0,0,2.25h4.5a1.122,1.122,0,0,0,1.125-1.125V7.875A1.122,1.122,0,0,0,14.625,6.75Zm0,0",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M9.969,8.07A1.934,1.934,0,0,0,8,10.021V23.961a1.934,1.934,0,0,0,1.969,1.951H24.031A1.934,1.934,0,0,0,26,23.961V10.021A1.934,1.934,0,0,0,24.031,8.07Zm4.781,2.092h4.5v5.625a1.1,1.1,0,0,1-1.125,1.125h-2.25a1.1,1.1,0,0,1-1.125-1.125Zm1.125,9h2.25a1.122,1.122,0,0,1,1.125,1.125v2.25a1.122,1.122,0,0,1-1.125,1.125h-2.25a1.122,1.122,0,0,1-1.125-1.125v-2.25A1.122,1.122,0,0,1,15.875,19.162Zm0,0",
    transform: "translate(10 10.088)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleButtonIcon);
export default __webpack_public_path__ + "static/media/scheduleButtonIcon.e98c74310e047b5df0d019630726f8a5.svg";
export { ForwardRef as ReactComponent };